import { Fragment } from 'react';
import { TFunction } from 'i18next';
import { Slide, toast } from 'react-toastify';

const ErrorToast = (errorMessage: string, t?: TFunction) => (
  <Fragment>
    <div className="toastify-header">
      <div className="title-wrapper">
        <h6 className="toast-title">
          {t ? t('ERROR_TOAST_TITLE_TEXT') : 'Error!'}
        </h6>
      </div>
      <small className="text-muted">
        {t ? t('ERROR_TOAST_TIME_TEXT') : 'a second ago'}
      </small>
    </div>
    <div className="toastify-body">
      <span role="img" aria-label="toast-text">
        {errorMessage}
      </span>
    </div>
  </Fragment>
);

const SuccessToast = (message: string, t?: TFunction) => (
  <Fragment>
    <div className="toastify-header">
      <div className="title-wrapper">
        <h6 className="toast-title fw-bold">Welcome, {name}</h6>
      </div>
    </div>
    <div className="toastify-body">
      <span>{message}</span>
    </div>
  </Fragment>
);

const SuccessRequestToast = (message: string, t?: TFunction) => {
  return (
    <Fragment>
      <div className="toastify-header">
        <div className="title-wrapper">
          <h6 className="toast-title fw-bold">
            {t ? t('SUCCESS_TOAST_TEXT') : 'Success,'}
          </h6>
        </div>
      </div>
      <div className="toastify-body">
        <span>{message}</span>
      </div>
    </Fragment>
  );
};

const Toast = (type: string, message: string, t?: TFunction) => {
  const text = JSON.stringify(message);
  if (type === 'error') {
    toast.error(ErrorToast(text, t), {
      icon: false,
      hideProgressBar: true,
    });
  } else if (type === 'success-request') {
    toast.success(SuccessRequestToast(text, t), {
      icon: false,
      transition: Slide,
      hideProgressBar: true,
      autoClose: 5000,
    });
  } else {
    toast.success(SuccessToast(text, t), {
      icon: false,
      transition: Slide,
      hideProgressBar: true,
      autoClose: 5000,
    });
  }
};

export default Toast;
